/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Daterangepicker_Maxrange3Inputs */

const id_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rentang maksimum adalah 30 hari`)
};

const ms_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julat maksimum ialah 30 hari`)
};

const da_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksimal rækkevidde er 30 dage`)
};

const de_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximaler Bereich ist 30 Tage`)
};

const en_us2_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum range is 30 days`)
};

const es_es2_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El rango máximo es de 30 días`)
};

const es_mx2_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El rango máximo es de 30 días`)
};

const fil_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang maximum range ay 30 araw`)
};

const fr_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La durée maximale est de 30 jours`)
};

const it_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intervallo massimo è di 30 giorni`)
};

const hu_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum 30 napos intervallum`)
};

const nl_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum bereik is 30 dagen`)
};

const no_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksimalt område er 30 dager`)
};

const pl_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksymalny zakres to 30 dni`)
};

const pt_br2_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum range is 30 days`)
};

const pt_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O intervalo máximo é de 30 dias`)
};

const ro_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalul maxim este de 30 de zile`)
};

const fi_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enimmäisväli on 30 päivää`)
};

const sv_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximalt intervall är 30 dagar`)
};

const vi_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phạm vi tối đa là 30 ngày`)
};

const tr_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksimum aralık 30 gündür`)
};

const cs_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximální rozsah je 30 dní`)
};

const bg_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максималният обхват е 30 дни`)
};

const ru_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальный диапазон — 30 дней`)
};

const uk_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальний діапазон — 30 днів`)
};

const ar_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحد الأقصى 30 يومًا`)
};

const hi_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम सीमा 30 दिन`)
};

const th_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วงสูงสุดคือ 30 วัน`)
};

const ja_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大範囲は30日間です`)
};

const zh_cn2_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大范围为30天`)
};

const zh_hant1_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum range is 30 days`)
};

const ko_components_daterangepicker_maxrange3 = /** @type {(inputs: Components_Daterangepicker_Maxrange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최대 범위는 30일입니다`)
};

/**
* | output |
* | --- |
* | "Maximum range is 30 days" |
*
* @param {Components_Daterangepicker_Maxrange3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_daterangepicker_maxrange3 = /** @type {((inputs?: Components_Daterangepicker_Maxrange3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Daterangepicker_Maxrange3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_daterangepicker_maxrange3(inputs)
	if (locale === "ms") return ms_components_daterangepicker_maxrange3(inputs)
	if (locale === "da") return da_components_daterangepicker_maxrange3(inputs)
	if (locale === "de") return de_components_daterangepicker_maxrange3(inputs)
	if (locale === "en-US") return en_us2_components_daterangepicker_maxrange3(inputs)
	if (locale === "es-ES") return es_es2_components_daterangepicker_maxrange3(inputs)
	if (locale === "es-MX") return es_mx2_components_daterangepicker_maxrange3(inputs)
	if (locale === "fil") return fil_components_daterangepicker_maxrange3(inputs)
	if (locale === "fr") return fr_components_daterangepicker_maxrange3(inputs)
	if (locale === "it") return it_components_daterangepicker_maxrange3(inputs)
	if (locale === "hu") return hu_components_daterangepicker_maxrange3(inputs)
	if (locale === "nl") return nl_components_daterangepicker_maxrange3(inputs)
	if (locale === "no") return no_components_daterangepicker_maxrange3(inputs)
	if (locale === "pl") return pl_components_daterangepicker_maxrange3(inputs)
	if (locale === "pt-BR") return pt_br2_components_daterangepicker_maxrange3(inputs)
	if (locale === "pt") return pt_components_daterangepicker_maxrange3(inputs)
	if (locale === "ro") return ro_components_daterangepicker_maxrange3(inputs)
	if (locale === "fi") return fi_components_daterangepicker_maxrange3(inputs)
	if (locale === "sv") return sv_components_daterangepicker_maxrange3(inputs)
	if (locale === "vi") return vi_components_daterangepicker_maxrange3(inputs)
	if (locale === "tr") return tr_components_daterangepicker_maxrange3(inputs)
	if (locale === "cs") return cs_components_daterangepicker_maxrange3(inputs)
	if (locale === "bg") return bg_components_daterangepicker_maxrange3(inputs)
	if (locale === "ru") return ru_components_daterangepicker_maxrange3(inputs)
	if (locale === "uk") return uk_components_daterangepicker_maxrange3(inputs)
	if (locale === "ar") return ar_components_daterangepicker_maxrange3(inputs)
	if (locale === "hi") return hi_components_daterangepicker_maxrange3(inputs)
	if (locale === "th") return th_components_daterangepicker_maxrange3(inputs)
	if (locale === "ja") return ja_components_daterangepicker_maxrange3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_daterangepicker_maxrange3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_daterangepicker_maxrange3(inputs)
	return ko_components_daterangepicker_maxrange3(inputs)
});
export { components_daterangepicker_maxrange3 as "components.dateRangePicker.maxRange" }